import React, { useState, useContext, useEffect } from "react";
import { AiOutlineMenuUnfold } from "react-icons/ai";
import { RiUserSettingsLine, RiDashboardLine } from "react-icons/ri";
import { TbUserEdit } from "react-icons/tb";
import { LuUserSearch } from "react-icons/lu";
import { IoIosLogOut } from "react-icons/io";
import { AiOutlineUserAdd } from "react-icons/ai";
import { AiOutlineMenuFold } from "react-icons/ai";
import { NavLink, useLocation  } from "react-router-dom";
import "../index.css";
import "../component/AdminNavBar.css";
import { AiOutlineUserDelete } from "react-icons/ai";
import Header from "./Header";
import { FaTasks } from "react-icons/fa";
import { FiActivity } from "react-icons/fi";
import { MdWorkOutline } from "react-icons/md";
import { ReadOutlined } from "@ant-design/icons";
//import WorkOutlineIcon from '@mui/icons-material/WorkOutline';

const AdminNavBar = ({ setActivePage, setSidebarOpen }) => {
  const [open, setOpen] = useState(true);
  const [openSubmenus, setOpenSubmenus] = useState({});
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
  const basePath = sessionStorage.getItem("APP_BASE_PATH");
  const location = useLocation();
  const segments = location.pathname.split("/").filter(Boolean); // remove empty strings
  console.log('segments',segments)
const activeMenu = basePath ? segments[1] : segments[0];
  // const activeMenu = location.pathname.startsWith('/dashboard');
  const toggleSubmenu = (menuName) => {
    setOpenSubmenus((prev) => ({
      ...prev,
      [menuName]: !prev[menuName], // Toggle only the clicked submenu
    }));
  };

  const handleSidebarToggle = () => {
    setOpen(!open);
    setSidebarOpen(!open); // Update the sidebar state in the parent component
  };
  useEffect(()=>{
    setOpenSubmenus((prev) => ({
      ...prev,
      [activeMenu]: true, // Toggle only the clicked submenu
    }));
  },[activeMenu])
  const menus = [
    {
      name: "Dashboard",
      link: "dashboard",
      icon: RiDashboardLine,
      submenu: [
        {
          name: "Compliance Dashboard",
          link: `${basePath}/dashboard/compliance-dashboard`,
          icon: RiDashboardLine,
        },
      ],
    },
    {
      name: "User Maintenance",
      link: "user-maintenance",
      icon: RiUserSettingsLine,
      submenu: [
        {
          name: "User Onboarding",
          link: `${basePath}/user-maintenance/add-user`,
          icon: AiOutlineUserAdd,
        },
      ],
    },
    {
      name: "User Management",
      link: "user-management",
      icon: TbUserEdit,
      submenu: [
        {
          name: "Onboarding",
          link: `${basePath}/user-management/Onboarding`,
          icon: AiOutlineUserAdd,
        },
      ],
    },
    {
      name: "Search",
      link: "search",
      icon: LuUserSearch,
      submenu: [
        {
          name: "Search Employees",
          link: `${basePath}/search/employees`,
          icon: LuUserSearch,
        },
        {
          name: "Search Skill Set",
          link: `${basePath}/search/skillSet`,
          icon: LuUserSearch,
        },
      ],
    },
    {
      name: "Job Portal",
      link: "jobs",
      icon: MdWorkOutline,
      submenu: [
        {
          name: "Create Job",
          link: `${basePath}/jobs/create-job`,
          icon: AiOutlineUserAdd,
        },
        {
          name: "View Job",
          link: `${basePath}/jobs/search`,
          icon: AiOutlineUserAdd,
        },
      ],
    },
    {
      name: "Account Activity",
      link: "activity",
      icon: FiActivity,
      submenu: [
        {
          name: "Create Activity",
          link: `${basePath}/activity/accountActivity`,
          icon: FaTasks,
        },
      ],
    },
    {
      name: "Training Portal",
      link: "training",
      icon: ReadOutlined,
      submenu: [
        {
          name: "Create Training",
          link: `${basePath}/training/trainingportal`,
          icon: FaTasks,
        },
      ],
    },
  ];

  return (
    <>
      <div
        className={`bg-white h-[calc(100vh-70px)] ${
          open ? "w-26-vw" : "w-[5.3vw]"
        } duration-500 text-black-100 px-4 top-[70px] left-0 overflow-y-auto fixed shadow-md`}
      >
        <div className="py-3 flex justify-end">
          {open ? (
            <AiOutlineMenuFold
              size={26}
              className="cursor-pointer"
              onClick={handleSidebarToggle}
            />
          ) : (
            <AiOutlineMenuUnfold
              size={26}
              className="cursor-pointer"
              onClick={handleSidebarToggle}
            />
          )}
        </div>

        <div className="mt-4 flex flex-col gap-4 relative">
          {menus.map((menu, i) => (
            <div key={i}>
              {/* Parent Menu Item */}
              <div
                className={`group flex  items-center text-sm gap-3.5 font-medium p-2 hover:bg-[#1f415b] rounded-md cursor-pointer  text-gray-500 hover:text-white pr-6
                  ${
                !open && menu.link === activeMenu ? "bg-[#1f415b] text-white" : ""
                  }
                  `}
                onClick={() => menu.submenu && toggleSubmenu(menu.link)}
              >
                <div>{React.createElement(menu.icon, { size: "20" })}</div>
                <h2
                  style={{ transitionDelay: `${i + 3}00ms` }}
                  className={`whitespace-pre duration-500 ${
                    !open && "opacity-0 translate-x-28 overflow-hidden"
                  }`}
                >
                  {menu.name}
                </h2>

                {/* Show Expand/Collapse Arrow for Submenus */}
                {menu.submenu && (
                  <span className="ml-auto">
                    {openSubmenus[menu.name] ? "▼" : "▶"}
                  </span>
                )}
              </div>

              {/* Submenu Items */}
              {menu.submenu && openSubmenus[menu.link] && (
                <div className="ml-8 flex flex-col gap-2 mt-2">
                  {menu.submenu.map((sub, j) => (
                    <NavLink
                      to={sub.link}
                      key={j}
                      className={({ isActive }) =>
                        isActive
                          ? "flex items-center text-sm p-2 pl-4 rounded-md bg-[#1f415b] text-white"
                          : "flex items-center text-sm p-2 pl-4 hover:bg-[#1f415b] rounded-md  text-gray-500 hover:text-white"
                      }
                    >
                      {sub.icon &&
                        React.createElement(sub.icon, {
                          size: 18,
                          className: "mr-2 text-black-600",
                        })}
                      <span className="whitespace-nowrap">{sub.name}</span>
                    </NavLink>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      <div
        className={`transition-all duration-500 flex-1 bg-white-100 ${
          open ? "ml-52 p-20" : "ml-20 p-0"
        } ml-0`}
      ></div>
    </>
  );
};

export default AdminNavBar;
